import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { SharedModule } from './shared/shared.module';
import { FormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpContextToken } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DashboardModule } from './dashboard/dashboard.module';
import { NgChartsModule } from 'ng2-charts';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

// Request with status 404 are always redirected unless this token is set to false
export const REDIRECT_REQUEST = new HttpContextToken<boolean>(() => true);

const maskConfig: Partial<NgxMaskConfig> = {
  validation: true,
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        DashboardModule,
        CoreModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            }
        }),
        NgChartsModule,
        PrivacyPolicyComponent,
    ],
    bootstrap: [AppComponent],
    providers: [
        provideEnvironmentNgxMask(maskConfig),
    ],
})
export class AppModule {}
